import React from "react"
// import ReservationSegmentBuilderGuestTypes from "../../ReservationSegmentBuilder/steps/ReservationSegmentBuilderGuestTypes"
import DateHelper from '../../DateHelper/DateHelper';
import { format, parseISO } from 'date-fns';
import I18n from "i18n-js";

class DetailsAccommodationSection extends React.Component {

  constructor(props) {
    super(props)

  }

  render() {
    var room_label = "room_identifier"
    var source = null
    if (this.props.reservation_segment.check_in_check_out_time_source && this.props.reservation_segment.check_in_check_out_time_source == "Rate") {
      source = "(Set in Rate)"
    } else if (this.props.reservation_segment.check_in_check_out_time_source && this.props.reservation_segment.check_in_check_out_time_source == "Reservation Setting") {
      source = "(Set by Property Setting)"
    } else if (this.props.reservation_segment.check_in_check_out_time_source && this.props.reservation_segment.check_in_check_out_time_source == "Override") {
      source = "(Overridden by Room)"
    }


    if ((this.props.reservation_segment && this.props.reservation_segment.room_type.type_of_booking == "room_group") || (this.props.room_type && this.props.room_type.type_of_booking == "room_group")) {
      room_label = "room_group_identifier"
    }


    return(
      <div>
        <div className="row spacer" >
          <div className="col-sm-6">
            <label>{I18n.t('room_type')}</label>
            <br />
            {this.renderRoomType()}
          </div>
          <div className="col-sm-6">
            <label>{I18n.t(room_label)}</label>
            <br />
         
            {this.renderRoom()}
          </div>
        </div>

        <br></br>

        {this.props.reservation_segment.status != "held" ?
          <div>
            <div className="row spacer">
              <div className="col-sm-6">
                <label>{I18n.t('rate')}</label>
                <br />
                {this.renderRates()}
              </div>
             
              <div className="col-sm-6">
             
                {this.renderGuestTypes()}

              </div>
            </div>
            <br></br>
            <div className="row spacer">
              <div className="col-sm-6">
                <label>{I18n.t('check_in_time')} {source}</label>

                <br />
           
                <div>
                  {DateHelper.printDateToScreen(DateHelper.parseDate(this.props.reservation_segment.check_in_time), this.props.time_format)}
                </div>
                


              </div>
              <div className="col-sm-6">
                <label>{I18n.t('check_out_time')} {source}</label>
                <br />
          
                <div>
                  {DateHelper.printDateToScreen(DateHelper.parseDate(this.props.reservation_segment.check_out_time), this.props.time_format)}
                </div>
                
              </div>
            </div>
          </div>
          :
          null
        }
      </div>
    )
  }

  renderGuestTypes(){
    var self = this;
    if (this.props.guest_types && this.props.guest_types.length > 0) {
      var guest_types = this.props.guest_types.sort((a,b) => a.position - b.position).map(function(guest_type, index) {
        var number_of_guests = 0        
        self.props.reservation_segment.reservation_segment_guest_types.map((rsgt) => {   
          if (rsgt.guest_type_id == guest_type.id) {
            number_of_guests = rsgt.number_of_guests
          }
        })
        if(number_of_guests != 0) {
          return(
            <div className='row guest-type-form' key={`${guest_type.id}${index}`}>
              <div className="col-sm guest-number-name-wrapper">
                <span className="name">{guest_type.name}</span>
              </div>
              <span className="number-of-guests">
                {number_of_guests}
              </span>
            </div>
          )
        }
      })
    }
    return(
      <div className="row">
        <div className="col-sm-12">
          <label>{I18n.t('guest_types')}</label>
          {
            this.props.reservation_segment.guest_types && this.props.reservation_segment.guest_types.length > 0
            ?
            <p>{I18n.t('max_occupancy_reached', {max_occupancy: this.props.reservation_segment.room_type.maximum_occupancy})}</p>
            :
            null
          }
          {guest_types}
        </div>
      </div>
    )
  }

  renderRoom() {
    var identifier = I18n.t('not_assigned')
    var room = { id: "unassigned", identifier: I18n.t("not_assigned") };

    if(this.props.reservation_segment.room) {
      identifier = this.props.reservation_segment.room.identifier
      room = this.props.reservation_segment.room
    } else if (this.props.reservation_segment.room_group) {
      identifier = this.props.reservation_segment.room_group.identifier
      room = this.props.reservation_segment.room_group
    }


    if (this.props.reservation_segment.parent_reservation_segment) {

      var parent_segment = this.props.reservation_segment.parent_reservation_segment
      if (Object.keys(parent_segment.room).length) {
        parent_segment_room = parent_segment.room.identifier
        moved_from = "moved_from_room"
      } else if (Object.keys(parent_segment.room_group).length) {
        parent_segment_room = parent_segment.room_group.identifier
        moved_from = "moved_from_room_group"
      }
    }

    return (
      <div className="room">
        <div>{identifier}</div> 
        {this.props.reservation_segment.parent_reservation_segment ? <div>*{I18n.t(moved_from) + " " + parent_segment_room}</div> : null }
      </div>
    );
  }

  renderRoomType() {
    return (
      <div className="room-type">
        <div>{this.props.reservation_segment ? this.props.reservation_segment.room_type.name : this.props.room_type.name}</div>   
      </div>
    );
  }

  renderRates() {
    var self = this
    return(
      <div className="rate">   
        <div>{self.props.reservation_segment.rate ? self.props.reservation_segment.rate.code : ""}</div>    
      </div>
    )
  }

}

export default DetailsAccommodationSection
